import { ServiceRequestConfig } from '~/services/createService';
import { k2 } from '~/services/serviceInstances';

import { UnpublishWorkflowApiResponse } from '../../types/k2/workflows';

type Request = {
  workflowId: string;
};

type ServerResponse = UnpublishWorkflowApiResponse;

export const unpublishWorkflowK2 = async (
  request: Request,
  options: ServiceRequestConfig = {},
) => {
  const serverResponse: ServerResponse = await k2.patch(
    `/workflows/${request.workflowId}/unpublish`,
    undefined,
    { showErrorToast: true, ...options },
  );

  return mapResponse(serverResponse);
};

const mapResponse = (serverResponse: ServerResponse) => {
  if (serverResponse === null) {
    return null;
  }

  return {
    id: serverResponse.data.id,
    ...serverResponse.data.attributes,
  };
};
